export const getErrorText = (
  type: string,
  defalulMsg: { errorText?: string; patternMsg?: string; validateErrorText?: string }
): string => {
  const { errorText, patternMsg, validateErrorText } = defalulMsg;
  switch (type) {
    case 'max':
    case 'min':
      return 'Not correct value';
    case 'pattern':
      // pattern?.message
      return patternMsg || errorText || 'validation error';
    case 'validate':
      return validateErrorText || errorText || 'validation error';
    case 'required':
      return errorText || 'Please fill all the required fields';
    default:
      return errorText || 'Undefined Error';
  }
};
